import { Box } from '@amzn/awsui-components-core';
import { ContentRequest, ContentRequestState } from '@amzn/awscat-pattern-library-service-model';
import React, { useContext, useEffect, useState } from 'react';

import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import FlashbarMessageBroker from '../../common/FlashbarMessageBroker';
import ContentRequestActionButtons from './ContentRequestActionButtons';
import '../../resources/styles/scss/components/content-request/content-request-assignment-table.scss';
import { AppContext } from '../../contexts/AppContext';
import { convertEntities } from '@amzn/awscat-editor';

interface Props {
  contentRequest: ContentRequest;
}

const DESCRIPTION_DISPLAY_LIMIT = 20;

let mplServiceClient: IMplServiceClient;
let flashbarMessageBroker: FlashbarMessageBroker;

const ContentRequestActionColumn = (props: Props) => {
  const [contentRequest, setContentRequest] = useState<ContentRequest>(props.contentRequest);
  const appContext = useContext(AppContext);

  useEffect(() => {
    mplServiceClient = MplServiceClientFactory.create();
    flashbarMessageBroker = FlashbarMessageBroker.create();
  }, []);

  useEffect(() => {
    setContentRequest(props.contentRequest);
  }, [props.contentRequest]);

  const showReloadNotice = () => {
    flashbarMessageBroker.pushSuccessMessage(
      constants.CONTENT_REQUEST_ASSIGNMENT_TABLE_REFRESH_NOTICE,
    );
  };

  const updateContentRequest = async (
    contentRequestId: string,
    state: ContentRequestState,
    assigneeId: string,
  ): Promise<void> => {
    const updatedContentRequestResponse = await mplServiceClient.updateContentRequests(
      contentRequestId,
      state,
      { assigneeId },
    );
    if (state === ContentRequestState.REQUESTED || state === ContentRequestState.ASSIGNED) {
      showReloadNotice();
    }
    setContentRequest(updatedContentRequestResponse.contentRequest);
  };

  const { description } = contentRequest.contentRequestData;
  const resolvedDescription = convertEntities(description, appContext.entities);
  const truncatedDescription = resolvedDescription.substring(0, DESCRIPTION_DISPLAY_LIMIT).trim();

  return (
    <div className="cr-assignment-table-desc-col">
      <span>
        {truncatedDescription}
        {resolvedDescription.length > DESCRIPTION_DISPLAY_LIMIT ? '...' : ''}
      </span>
      <Box float="right">
        <ContentRequestActionButtons
          updateContentRequest={updateContentRequest}
          contentRequest={contentRequest}
        />
      </Box>
    </div>
  );
};

export default ContentRequestActionColumn;
